<template>
  <v-list
    class="bg-dropdown pt-1 pb-1"
  >
    <v-list-group
      v-model="opened"
      class="sidebar-dropdown-link"
    >
      <template #activator>
        <v-list-item-icon>
          <slot name="icon">
            <span class="sidebar-link__icon-dropwdown">
              <svg xmlns="http://www.w3.org/2000/svg">
                <use xlink:href="#icon-paper" />
              </svg>
            </span>
          </slot>
        </v-list-item-icon>
        <v-list-item-title>
          <b class="sidebar-link__icon-dropwdown pl-2">
            {{ title }}
          </b>
        </v-list-item-title>
      </template>
      <v-list-item
        v-for="item in items"
        :key="item.title"
        class="link-dropdown"
        link
        :to="item.to ? {
          name: item.to.name,
          query:item.to.query
        } : ''"
        style="display: flex !important; align-items: center !important"
      >
        <v-list-item-title>
          <b
            v-if="!item.routes || !item.routes.length"
            class="pl-nav-item"
          >
            {{ item.title }}
          </b>
          <div v-else>
            <SubGroup
              :sub-group="item.routes"
              :title="item.title"
            />
          </div>
        </v-list-item-title>
      </v-list-item>
    </v-list-group>
  </v-list>
</template>
<script>
import SubGroup from "./SubGroup.vue";
export default {
  components:{
    SubGroup
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  data(){
    return {
      opened: false,
    }
  },
  computed:{
    expanded(){
      return this.$store.state.navbar_expanded;
    },
  },
  watch:{
    expanded(value)
    {
      if(!value){
        this.opened = false;
      }
    },
  },
}
</script>
<style lang="scss">
.v-list-item--link:before{
  background: none;
}
</style>
